export * from './decoration-pixelization-form.component';
